/*
 * Today (green) / Schedule (orange) per order row (owner 10-24). Pure: no React, no network.
 *
 * Placement: the existing orders/create body's `schedule` field ("f" = Today, "t" = Schedule; the gateway's
 * CreateOrdersSchema default is "f") - the same flag the dashboard card shows as "Today" / "Schedule" and the
 * order history lists under "Scheduled orders". The order date stays the visit's date.
 *
 * Default: BlinkScribe (order_suggest_v2/when.py) sends when "today" | "schedule" + when_conf + when_src
 * (model | said | chart | history | labs_drawn) on every live / review row. A row without it (an older payload) is
 * Today - the clinic's own history (9928, 180 days): every order type is placed Today more often than Schedule.
 * The provider's tap is kept per visit + concept in the review record (rec.when), so a choice made on the live card
 * is the same in the end-of-visit review.
 */
export const WHENS = ["today", "schedule"];
export const WHEN_LABEL = { today: "Today", schedule: "Schedule" };
export const WHEN_COLORS = {
  today: { bg: "#DCFCE7", border: "#16A34A", fg: "#166534" },
  schedule: { bg: "#FFEDD5", border: "#EA580C", fg: "#9A3412" },
};

const valid = (w) => (WHENS.includes(w) ? w : null);

// BlinkScribe's default for a row, else Today.
export const defaultWhen = (row) => valid(row && row.when) || "today";

// The mode a row is placed with: the provider's tap (rec.when[concept]) over the default.
export const whenFor = (rec, row) => {
  const picked = row && row.concept && rec && rec.when ? valid(rec.when[row.concept]) : null;
  return picked || defaultWhen(row);
};

export const otherWhen = (w) => (w === "schedule" ? "today" : "schedule");

export const recordWhen = (rec, concept, when) => ({
  ...(rec || {}),
  when: { ...((rec && rec.when) || {}), [concept]: valid(when) || "today" },
});

// orders/create's schedule flag.
export const scheduleFlag = (when) => (when === "schedule" ? "t" : "f");

// The toggle's accessible name: what it is now and what a tap does (never colour only).
export const whenAriaLabel = (name, when) => `${name}: ${WHEN_LABEL[when] || "Today"}. Tap to switch to ${WHEN_LABEL[otherWhen(when)]}`;
